import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { ClipLoader } from 'react-spinners'
import moment from 'moment'
import { ResourceComponent } from './components/AgendaItem'
import { useFetchResources } from '../../hooks'
import { resourceIsCurrent } from '../../../../utils'

export default function AgendaView() {
  const { organization, dateFilter, config } = useSelector(state=>state)
  const { showSidePanel } = config
  const { date } = dateFilter
  const { resources, isFetchingResources } = useFetchResources()
  const isToday = (date == moment().format("YYYY-MM-DD"))
  
  return (
    <div id="agendaView" className="d-flex p-3 flex-column pb-3" style={{height: 'calc(100% - 77px)', overflowY: 'scroll', backgroundColor: !config.isStaffApp && 'rgba(0,0,0,0.03)'}}>
      {
        isFetchingResources ? 
        <div className="w-100 h-100 d-flex justify-content-center align-items-center">
          <ClipLoader color="#20a8d8"/> 
        </div>
        :( 
          resources.length > 0 ?
          <div>
            <ResourcesByStatus 
              organization={organization} 
              label="Pending Review" 
              resources={resources.filter(resource => resource.status == 'pending_completing')}/> 
            <ResourcesByStatus 
              organization={organization} 
              label="Review" 
              resources={resources.filter(resource => resource.status == 'completed')}/> 
            { isToday && 
              <ResourcesByStatus 
                organization={organization} 
                label="Overdue" 
                resources={resources.filter(resource => resource.status == 'overdue')}/> 
            }
            <ResourcesByStatus 
              organization={organization} 
              label={isToday && "Today"} 
              resources={resources.filter(resource => resourceIsCurrent(resource))}/>
            <ResourcesByStatus 
              organization={organization} 
              label="Upcoming" 
              resources={resources.filter(resource => resource.status == 'upcoming')}/> 
            { showSidePanel && <div className="w-100 pb-5 pt-5 mt-5 mb-5"/> }
          </div>
          :
          <div className="w-100 h-100 d-flex align-items-center justify-content-center">
            <h4 className="text-center">Nothing scheduled for {moment(date).format("MMMM DD, YYYY")}.</h4>
          </div>
        )
      }
    </div>
  )
}

function ResourcesByStatus(props){
  const { resources, label, organization } = props
  return (
    resources.length > 0 &&
    <div className="mt-2">
      <h5 className="pb-2">{label}</h5>
      {resources.map((resource, index) => (
        <ResourceComponent key={index} {...resource} organization={organization}/>
      ))}
    </div>

  )
}